import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  Box,
  CardContent,
  Typography,
  Chip,
  Popover,
} from "@mui/material";
import ProductImage from "../../Product/Utils/ProductImage";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import IconButton from "@mui/material/IconButton";


export default function ProductCard({ product }) {
  const [priceInfoAnchor, setPriceInfoAnchor] = useState(null);
  const priceInfoOpen = Boolean(priceInfoAnchor);

  const handlePriceInfoClick = (event) => {
    setPriceInfoAnchor((current) => (current ? null : event.currentTarget));
  };

  const handlePriceInfoClose = () => {
    setPriceInfoAnchor(null);
  };

  // Backend Discount shape: { name, percent, end_date, variant?, category? }
  // There is no final_price/discount_price — derive it from percent.
  const activeDiscount =
    Array.isArray(product.discounts) && product.discounts.length > 0
      ? product.discounts[0]
      : null;

  const rawOriginalPrice = product.min_price || product.price;

  const discountPercentNum = Number(
    activeDiscount?.percent ?? activeDiscount?.discount_percent ?? 0,
  );

  const rawFinalPrice =
    activeDiscount &&
    rawOriginalPrice &&
    discountPercentNum > 0 &&
    discountPercentNum < 100
      ? String(
          Math.round(Number(rawOriginalPrice) * (1 - discountPercentNum / 100)),
        )
      : rawOriginalPrice;

  const hasPrice =
    rawFinalPrice !== null &&
    rawFinalPrice !== undefined &&
    rawFinalPrice !== "";
  const isAvailable = product.in_stock ?? hasPrice;

  // Backend sends prices in toman — display as-is (no Rial→Toman conversion).
  const productPriceInToman = hasPrice
    ? Math.floor(Number(rawFinalPrice))
    : null;
  const originalPriceInToman =
    activeDiscount &&
    rawOriginalPrice &&
    Number(rawOriginalPrice) > Number(rawFinalPrice)
      ? Math.floor(Number(rawOriginalPrice))
      : null;

  const discountPercent =
    activeDiscount?.percent || activeDiscount?.discount_percent || null;

  return (
    <Card
      sx={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        boxSizing: "border-box",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: { xs: 2, md: 2.5 },
        position: "relative",
        overflow: "hidden",
        bgcolor: "#fff",
        border: "1px solid",
        borderColor: "grey.200",
        boxShadow: "0 2px 8px rgba(0,0,0,0.02)",
        transition: "box-shadow 0.2s ease",
        "&:hover": {
          boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        },
      }}
    >
      {!isAvailable && (
        <Chip
          label="اتمام موجودی"
          size="small"
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 2,
            bgcolor: "rgba(0, 0, 0, 0.7)",
            color: "#fff",
            fontWeight: 700,
            fontSize: "0.75rem",
            borderRadius: 1.5,
            backdropFilter: "blur(4px)",
          }}
        />
      )}
      {/* Discounted Badge  */}
      {/* {isAvailable && activeDiscount && (
        <Chip
          label={discountPercent ? `٪${discountPercent}` : "تخفیف"}
          size="small"
          color="error"
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 2,
            fontWeight: 700,
            fontSize: "0.75rem",
            borderRadius: 1.5,
          }}
        />
      )} */}
      <Box
        component={Link}
        to={`/product/${product.slug}`}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          justifyContent: "flex-start",
          height: "100%",
          textDecoration: "none",
          color: "inherit",
          WebkitTapHighlightColor: "transparent",
          outline: "none",
        }}
      >
        <Box
          sx={{
            opacity: isAvailable ? 1 : 0.55,
            filter: isAvailable ? "none" : "grayscale(40%)",
            transition: "0.2s",
          }}
        >
          <ProductImage
            images={product.images}
            title={product.title}
            disableGallery={true}
          />
        </Box>

        <CardContent
          sx={{
            textAlign: "center",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            p: { xs: 1, sm: 1.25, md: 1.5 },
            "&:last-child": {
              pb: { xs: 1, sm: 1.25, md: 1.5 },
            },
          }}
        >
          <Typography
            sx={{
              height: "3em",
              lineHeight: 1.5,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              fontWeight: 600,
              fontSize: { xs: "0.8rem", md: "0.9rem" },
              color: isAvailable ? "text.primary" : "text.secondary",
              mb: 1,
            }}
          >
            {product.title || "نامشخص"}
          </Typography>
        </CardContent>
      </Box>

      {/* Product prices */}
      {/* <Box
        sx={{
          mt: "auto",
          pt: 1,
          px: { xs: 1, sm: 1.25, md: 1.5 },
          pb: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
        }}
      >
        {hasPrice && isAvailable && originalPriceInToman && (
          <Typography
            sx={{
              textDecoration: "line-through",
              color: "text.secondary",
              fontSize: { xs: "0.75rem", md: "0.85rem" },
              lineHeight: 1.2,
            }}
          >
            {originalPriceInToman.toLocaleString("en-US")}
          </Typography>
        )}

        <Box
          sx={{
            display: "flex",
            alignItems: "baseline",
            direction: "ltr",
            gap: 0.5,
            width: "100%",
            justifyContent: "flex-start",
          }}
        >
          {hasPrice && isAvailable && (
            <Box
              component="span"
              color="text.secondary"
              sx={{ fontSize: "0.75rem", fontWeight: 400 }}
            >
              تومان
            </Box>
          )}

          <Typography
            fontWeight={800}
            color={
              isAvailable
                ? activeDiscount
                  ? "error.main"
                  : "primary"
                : "text.secondary"
            }
            fontSize={{ xs: "0.95rem", md: "1.1rem" }}
          >
            {hasPrice && isAvailable
              ? productPriceInToman.toLocaleString("en-US")
              : "ناموجود"}
          </Typography>
        </Box>
      </Box> */}
    </Card>
  );
}
